const yaEventsMap = {
  /* Действия в разделе "Регистрация в приложении Nedvex" */
  Web_User_Registration: 'отправить',
  Web_Phone_Number_Entered: 'подтвердить',

  /* Подписка */
  SUBSCRIPTION: 'подписка',

  /* Действия в разделах "Новостройки" или "КП и ТХ" */
  Web_KP: 'вкладка_кптх',
  Web_ZHK: 'вкладка_новостройки',
  Web_ZHK_Nedvex: 'жк_nedvex',
  Web_New: 'новинки',
  Web_Stock: 'акции',
  Web_Popular: 'популярное',
  Web_Search: 'поиск_на_списке',
  Web_Sort_Date: 'сортировка_по_дате',
  Web_Sort_Price_Cheaper: 'сортировка_по_увеличение_цены',
  Web_Sort_Price_Expensive: 'сортировка_по_уменьшению_цены',
  Web_Sort_Title: 'сортировка_по_названию',
  Web_Filters_District: 'район',
  Web_Filters_Price: 'цена',
  Web_Filters_Price_General: 'общая_цена',
  Web_Filters_Price_Kv: 'цена_за_метр',
  Web_Filters_Square: 'площадь',
  Web_Filters_Decoration: 'оформление',
  'Web_Filters_FZ-214': 'фз214',
  'Web_Filters_FZ-215': 'фз215',
  Web_Filters_Part: 'договор_долевого_участия',
  Web_Filters_Loan: 'договор_займа',
  Web_Filters_Inv: 'договор_инвестирования',
  Web_Filters_Buy_Sale: 'договор_купли_продажи',
  Web_Filters_Contract: 'договор_подряда',
  Web_Filters_Prec: 'предварительный_договор',
  Web_Filters_Justice: 'юстиция',
  Web_Filters_Delivery_Deadline: 'срок_сдачи',
  Web_Filters_Passed: 'дом_сдан',
  Web_Filters_2024: '2024',
  Web_Filters_2025: '2025',
  Web_Filters_2026: '2026',
  Web_Filters_2027: '2027',
  Web_Filters_2028: '2028',
  Web_Filters_2029: '2029',
  Web_Filters_2030: '2030',
  Web_Filters_Payment_Options: 'варианты_оплаты',
  Web_Filters_Taxes: 'возврат_ндс',
  Web_Filters_Cash: 'наличный_расчет',
  Web_Filters_Mortgage: 'ипотека',
  Web_Filters_Installment: 'рассрочка',
  Web_Filters_Military_Mortgage: 'военная_ипотека',
  Web_Filters_Ipoteka_Family: 'ипотека_семейная',
  Web_Filters_Ipoteka_State_Support: 'ипотека_с_господдержкой',
  Web_Filters_Ipoteka_It: 'ипотека_it',
  Web_Filters_Ipoteka_Tranche: 'ипотека_траншевая',
  Web_Filters_Ipoteka_Subsidized: 'ипотека_субсидированная',
  Web_Filters_Ipoteka_Preferential: 'ипотека_льготная',
  Web_Filters_Maternity_Capital: 'материнский_капитал',
  Web_Filters_Сhist_Int: 'чистовая',
  Web_Filters_Chern_Int: 'черновая',
  Web_Filters_Pred_Сhist_Int: 'предчистовая',
  Web_Filters_Rem_Int: 'ремонт',
  Web_Filters_White_Box: 'white_box',
  Web_Filters_Repair: 'ремонт_мебель_техника',
  Web_Filters_Flat: 'квартира',
  Web_Filters_Apartments: 'апартаменты',
  Web_Filters_Zhiloe_Room: 'жилое_помещение',
  Web_Filters_Nezhiloe_Room: 'нежилое_помещение',
  Web_Filters_Hotel_Room: 'гостиничный_номер',
  Web_Filters_Zhiloe_House: 'жилой_дом',
  Web_Filters_Storage_Room: 'кладовое_помещение',
  Web_Filters_Up_To_500: 'до_500',
  Web_Filters_Up_To_1500: 'до_1500',
  Web_Filters_Up_To_3000: 'до_3000',
  Web_Filters_Economy: 'эконом',
  Web_Filters_Comfort: 'комфорт',
  Web_Filters_Business: 'бизнес',
  Web_Filters_Elite: 'элит',
  Web_Filters_Parking: 'паркинг',
  Web_Filters_Concierge: 'консьерж',
  Web_Filters_Recreation_Area: 'зона_отдыха',
  Web_Filters_Recreation_Elevator: 'лифт',
  Web_Filters_Children_Playground: 'детская_площадка',
  Web_Filters_Swimming_Pool: 'бассейн',
  Web_Filters_House_Territory: 'закрытая_территория',
  Web_Filters_SPA: 'spa',
  Web_Filters_CCTV: 'видеонаблюдение',
  Web_Filters_Commercial_Property: 'коммерческие_площади',
  Web_Filters_KPP: 'кпп',
  Web_Filters_Wellness_Building: 'оздоровительный_корпус',
  Web_Filters_Beach: 'пляж',
  Web_Filters_Walking_Area: 'прогулочные_зоны',
  Web_Filters_Restaurant: 'ресторан',
  Web_Filters_Sport_Area: 'спортивная_площадка',
  Web_Filters_Operated_Roof: 'эксплуатационная_кровля',
  Web_Filters_Zone_Bbq: 'зона_барбекю',
  Web_Filters_New: 'новинка',
  Web_Filters_Into_Yard: 'двор',
  Web_Filters_To_Mountains: 'горы',
  Web_Filters_On_Sea: 'море',
  Web_Filters_To_Park: 'парк',
  Web_Filters_To_Garden: 'сад',
  Web_Filters_To_Forest: 'лес',
  Web_Filters_On_Social_Objects: 'социальные_объекты',
  Web_Filters_Panoramic_View: 'панорамный_вид',
  Web_Map: 'искать_на_карте',
  Web_Map_Object_List: 'искать_на_списке',
  Web_Click: 'объект',
  Web_Add_To_Collection: 'в_подборку',
  Web_Add_To_Favorites: 'добавить_в_избранное',
  Web_Remove_From_Favorites: 'удалить_из_избранного',
  Web_List_News_All: 'новости_все',
  Web_List_News_Favorites: 'новости_избранных_объектов',
  Web_List_News_From_Service: 'новости_от_сервиса',

  /* Действия в "Карточке объекта" */
  Web_Card_Report_About_Inaccuracy: 'сообщить_о_неточности',
  Web_Card_Add_Selection: 'добавить_жк_в_подборку',
  Web_Card_Add_Favorites: 'добавить_жк_в_избранное',
  Web_Card_Remove_Favorites: 'удалить_жк_из_избранного',
  Web_Card_Share: 'поделиться_ссылкой',
  Web_Card_Print: 'печать_информации',
  Web_Card_Checkerboard: 'посмотреть_шахматку',

  /* Действия в "Шахматке объекта" */
  Web_List_Checkerboard: 'шахматка',
  Web_List_Premises: 'список_лотов',
  Web_List_Filters_Price: 'фильтр_цена_в_шахматке',
  Web_List_Filters_Price_General: 'фильтр_общая_цена_в_шахматке',
  Web_List_Filters_Price_Kv: 'фильтр_цена_за_метр_в_шахматке',
  Web_List_Filters_Square: 'фильтр_площадь_в_шахматке',
  Web_List_Filters_Finishing: 'фильтр_чистовая_в_объекте',
  Web_List_Filters_WhiteBox: 'white_box_в_шахматке',
  Web_List_Filters_RMT: 'рмт_в_шахматке',
  Web_List_Filters_Repair: 'фильтр_ремонт_в_объекте',
  Web_List_Filters_Rough: 'фильтр_черновая_в_объекте',
  Web_List_Filters_Partial_Repair: 'фильтр_частичный_ремонт_в_объекте',
  Web_List_Filters_Pre_Finishing: 'фильтр_пред_чистовая_в_объекте',
  Web_List_Filters_Extended_Activation: 'фильтр_расширенная_шахматка',
  Web_List_Filters_Into_Yard: 'двор_в_шахматке',
  Web_List_Filters_To_Mountains: 'горы_в_шахматке',
  Web_List_Filters_On_Sea: 'море_в_шахматке',
  Web_List_Filters_To_Park: 'парк_в_шахматке',
  Web_List_Filters_To_Garden: 'сад_в_шахматке',
  Web_List_Filters_To_Forest: 'лес_в_шахматке',
  Web_List_Filters_On_Social_Object: 'социцальные_объекты_в_шахматке',
  Web_List_Filters_Panoramic_View: 'панорамный_в_шахматке',


  /* Действия в разделе "Подборки" */
  Web_Selections: 'подборки',
  Web_Current_Add_To_Collection: 'создать_подборку',
  Web_Selections_Duplicate: 'дублировать_в_подборке',
  Web_Selections_Delete: 'удалить_в_подборке',
  Web_Selections_Edit: 'переименовать_в_подборке',
  Web_Selections_Share: 'отправить_подборку_в_подборке',
  Web_Selections_Add_Comment: 'оставить_комеентарий_в_подборке',
  Web_Selections_Edit_Comment: 'редактировать_комментарий_в_подборке',
  Web_Selections_Delete_Comment: 'удалить_в_подборке',

  /* Действия в разделе "Избранное" */
  Web_Favorites_Delete: 'убрать_из_избранного',
  Web_Favorites_Go_Object: 'перейти_в_жк',

  /* Действия в разделе "Профиль" */
  Web_Profile: 'профиль',
  Web_My_Profile: 'мой_профиль',
  Web_Profile_Company: 'профиль_компании',
  Web_Profile_With_Client: 'я_с_клиентом',
  Web_Profile_Renew_Subscription: 'оплатить',

  /* Попап шаринга объекта */
  Web_ShareDialog_NameAddress: 'название и адрес',
  Web_ShareDialog_Description: 'описание и преимущества',
  Web_ShareDialog_Characteristics: 'характеристики',
  Web_ShareDialog_Communications: 'коммуникации',
  Web_ShareDialog_Checkout: 'оформление_в_отправляемой_презентации',
  Web_ShareDialog_Payment: 'оплата',
  Web_ShareDialog_Lots: 'лоты',
  Web_ShareDialog_Link: 'ссылка',
  Web_ShareDialog_CopyButton: 'скопировать',
  Web_ShareDialog_SavePdf: 'сохранить pdf-файл',

  /* Попап шаринга подборки */

  Web_ShareCollectionDialog_NameAddress: 'название и адрес в подборке',
  Web_ShareCollectionDialog_Description: 'описание и преимущества в подборке',
  Web_ShareCollectionDialog_Characteristics: 'характеристики в подборке',
  Web_ShareCollectionDialog_Communications: 'коммуникации в подборке',
  Web_ShareCollectionDialog_Checkout: 'оформление в подборке',
  Web_ShareCollectionDialog_Payment: 'оплата в подборке',
  Web_ShareCollectionDialog_Map: 'карта в подборке',
  Web_ShareCollectionDialog_Lots_0: 'показывать все лоты',
  Web_ShareCollectionDialog_Lots_1: 'только отобраннные лоты',
  Web_ShareCollectionDialog_Lots_2: 'не отображать лоты',
  Web_ShareCollectionDialog_Link: 'ссылка в подборке',
  Web_ShareCollectionDialog_CopyButton: 'скопировать в подборке',
  Web_Lots_AddToCollection: 'добавить_в_подборку',
  Web_Lots_AddToNewCollection: 'создание_подборки_при_добавлении_лота',

  Web_Profile_Payment_User: 'платящие_пользователи'
};

const keysMap = {
  mode: {
    title: 'вид',
    values: {
      map: 'карта',
      list: 'список'
    }
  },
  selected: {
    title: 'режим',
    values: {
      true: 'установка',
      false: 'снятие'
    }
  },
  name: 'название'
};

class ymService {
  sendEvent(eventName, params = {}) {
    const paramsKeys = Object.keys(params);
    const newParams = paramsKeys.length ? paramsKeys.reduce((acc, paramName) => {
      const value = params[paramName];

      if (!keysMap[paramName]) {
        acc[paramName] = value;
        return acc;
      }

      if (typeof keysMap[paramName] === 'string') {
        const name = keysMap[paramName];
        acc[name] = value;
        return acc;
      }

      const name = keysMap[paramName].title;
      acc[name] = keysMap[paramName].values[value];

      return acc;
    }, {}) : undefined;

    const name = yaEventsMap[eventName];

    ym(92364884, 'reachGoal', name, newParams ? {
      [name]: newParams
    } : undefined);

    console.log('tracker: ymService', 'reachGoal', name, newParams ? {
      [name]: newParams
    } : undefined);
  }
}

export default new ymService();



// WEBPACK FOOTER //
// ./src/services/ym.js